// ============================================================================
// THEME CONFIGURATION — AetherCore
// SITE: aethercore — Industrial steampunk digital goods platform
// Edit this file to retheme.
// Tailwind colors are sourced from here at build time.
// ============================================================================

const theme = {
  "id": "aethercore",
  "siteId": "aethercore",
  "orderPrefix": "ATC",
  "brand": {
    "name": "AetherCore",
    "short": "Aether",
    "legalName": "PT AETHER CORE DIGITAL"
  },
  "meta": {
    "title": "AetherCore | Industrial-Grade Top-Up & Digital Voucher Station",
    "description": "AetherCore — Stasiun pengisian energi aetherial untuk top-up game dan voucher digital Anda. Penyaluran bertekanan tinggi, harga pabrik, aman tier-Reactor.",
    "themeColor": "#00d5f2"
  },
  "assets": {
    "heroBg": "/hero_aethercore_bg.png",
    "logo": "/logo-aethercore.svg"
  },
  "copy": {
    "hero": {
      "titleLine1": "Engage the Core.",
      "titleLine2": "Power Your Steam Engine.",
      "subtitle": "Saluran top-up bertekanan tinggi langsung dari reaktor AetherCore. Pengisian instan menghantarkan kargo Diamond, UC, dan voucher digital langsung ke akun game-mu — aman, bertenaga uap, stabil tanpa kebocoran katup.",
      "searchPlaceholder": "Kalibrasi sensor: cari game, voucher, atau kargo data..."
    },
    "features": [
      {
        "label": "Steam pressure",
        "desc": "Pengiriman kilat bertekanan tinggi"
      },
      {
        "label": "Reactor Pricing",
        "desc": "Harga grosir level pasokan pabrik"
      },
      {
        "label": "Brassclad Security",
        "desc": "Transkripsi data dilindungi pelat kuningan"
      },
      {
        "label": "Boiler Room",
        "desc": "Teknisi siaga 24/7 di ruang mesin"
      }
    ],
    "cta": {
      "titlePrefix": "Daftar sebagai ",
      "titleHighlight": "Aether",
      "titleSuffix": " Engineer",
      "subtitle": "Bergabunglah dengan serikat agen reseller AetherCore. Dapatkan akses ke harga grosir reaktor terendah, panel kontrol mekanikal real-time, dan transmisi langsung dengan ruang mesin utama.",
      "button": "Koneksikan Transmisi"
    },
    "footer": {
      "tagline": "Pusat distribusi kargo digital bertenaga reaktor aetherial. Kecepatan selevel semburan uap, kekuatan setebal pelat besi — AetherCore. Control the pressure."
    }
  },
  "colors": {
    "primary": "#e68a00",
    "secondary": "#00d5f2",
    "accent": "#df3b15",
    "background": "#0b0d10",
    "card": "#181b20",
    "border": "#3d342c",
    "foreground": "#f5f2eb",
    "success": "#10B981",
    "destructive": "#EF4444",
    "gradientFrom": "#e68a00",
    "gradientTo": "#00d5f2"
  },
  "fonts": {
    "display": "'Cinzel', 'Share Tech Mono', monospace",
    "body": "'Plus Jakarta Sans', 'Inter', sans-serif",
    "mono": "'JetBrains Mono', 'Share Tech Mono', monospace",
    "googleFontsUrl": "https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&family=Share+Tech+Mono&family=Plus+Jakarta+Sans:wght@400;500;600&family=Inter:wght@400;500&display=swap"
  },
  "style": {
    "heroVisual": "aether-core",
    "mascotGlow": "drop-shadow(0 0 20px rgba(0, 213, 242, 0.5)) drop-shadow(0 0 40px rgba(230, 138, 0, 0.25))",
    "heroAccent1": "bg-primary/15",
    "heroAccent2": "bg-secondary/10"
  }
};

module.exports = theme;
